const types = {
  //Get Template name
  GET_CUSTOMER_ORDER_START: "GET_CUSTOMER_ORDER_START",
  GET_CUSTOMER_ORDER_SUCCESS: "GET_CUSTOMER_ORDER_SUCCESS",
  GET_CUSTOMER_ORDER_ERROR: "GET_CUSTOMER_ORDER_ERROR",
  GET_CUSTOMER_ORDER_RESET: "GET_CUSTOMER_ORDER_RESET",

  //Create Template name
  CREATE_CUSTOMER_ORDER_START: "CREATE_CUSTOMER_ORDER_START",
  CREATE_CUSTOMER_ORDER_SUCCESS: "CREATE_CUSTOMER_ORDER_SUCCESS",
  CREATE_CUSTOMER_ORDER_ERROR: "CREATE_CUSTOMER_ORDER_ERROR",
  CREATE_CUSTOMER_ORDER_RESET: "CREATE_CUSTOMER_ORDER_RESET",

  //delete Template name
  DELETE_CUSTOMER_ORDER_START: "DELETE_CUSTOMER_ORDER_START",
  DELETE_CUSTOMER_ORDER_SUCCESS: "DELETE_CUSTOMER_ORDER_SUCCESS",
  DELETE_CUSTOMER_ORDER_ERROR: "DELETE_CUSTOMER_ORDER_ERROR",
  DELETE_CUSTOMER_ORDER_RESET: "DELETE_CUSTOMER_ORDER_RESET",

  //update Template name
  UPDATE_CUSTOMER_ORDER_START: "UPDATE_CUSTOMER_ORDER_START",
  UPDATE_CUSTOMER_ORDER_SUCCESS: "UPDATE_CUSTOMER_ORDER_SUCCESS",
  UPDATE_CUSTOMER_ORDER_ERROR: "UPDATE_CUSTOMER_ORDER_ERROR",
  UPDATE_CUSTOMER_ORDER_RESET: "UPDATE_CUSTOMER_ORDER_RESET",

  //single item  name
  SINGLE_CUSTOMER_ORDER_START: "SINGLE_CUSTOMER_ORDER_START",
  SINGLE_CUSTOMER_ORDER_SUCCESS: "SINGLE_CUSTOMER_ORDER_SUCCESS",
  SINGLE_CUSTOMER_ORDER_ERROR: "SINGLE_CUSTOMER_ORDER_ERROR",
  SINGLE_CUSTOMER_ORDER_RESET: "SINGLE_CUSTOMER_ORDER_RESET",
};

export default types;
